import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mentionKindLabel, mentionPath } from '../../lib/chat/mentions';
import { SourceDocumentDialog } from './message-parts/SourceDocumentDialog';
const CHIP = 'inline-flex items-center rounded-md border border-border bg-muted px-1.5 py-px align-baseline text-[length:var(--fs-ui-body)] font-medium text-foreground no-underline hover:border-border-strong';
/**
 * A record someone @-mentioned, drawn as a chip. Most open their page; a
 * document opens in the same viewer citations use; a person is a label only.
 */ export function MentionChip({ kind, id, children }) {
    const [open, setOpen] = useState(false);
    if (kind === 'document') {
        const name = typeof children === 'string' ? children.replace(/^@/, '') : 'Document';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: `${CHIP} cursor-pointer`,
                    title: `${mentionKindLabel(kind)}: open it`,
                    onClick: ()=>setOpen(true),
                    children: children
                }),
                open ? /*#__PURE__*/ _jsx(SourceDocumentDialog, {
                    documentId: id,
                    name: name,
                    onClose: ()=>setOpen(false)
                }) : null
            ]
        });
    }
    const path = mentionPath(kind, id);
    if (!path) {
        return /*#__PURE__*/ _jsx("span", {
            className: CHIP,
            title: mentionKindLabel(kind),
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(Link, {
        className: CHIP,
        title: `${mentionKindLabel(kind)}: open it`,
        to: path,
        children: children
    });
}
